import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PayloadAction as RTKPayloadAction } from '@reduxjs/toolkit';
import { IImpersonationUserViewModel } from 'Types/Litium';
import { mergeStateWithPreloaded } from 'Scripts/Utils/mergeStateWithPreloaded';
import { impersonateApi } from 'Services/impersonateApi';
import { cartApi } from 'Services/cartApi';

interface IImpersonateUser {
    translations: IImpersonationUserViewModel['translations'];
    currentUser: IImpersonationUserViewModel['currentUser'];
    isImpersonating: IImpersonationUserViewModel['isImpersonating'];
}

export const initialState: IImpersonateUser = {
    translations: {},
    currentUser: null,
    isImpersonating: false,
};

const slice = createSlice({
    name: 'impersonateUser',
    initialState: mergeStateWithPreloaded('impersonateUser', initialState) as IImpersonateUser,
    reducers: {
        updateImpersonationBanner(state, action: PayloadAction<IImpersonationUserViewModel>) {
            state.translations = action.payload.translations;
            state.currentUser = action.payload.currentUser;
            state.isImpersonating = action.payload.isImpersonating;
        },
    },
    extraReducers: builder => {
        builder.addMatcher(
            impersonateApi.endpoints.impersonate.matchFulfilled,
            (state, action: RTKPayloadAction<IImpersonationUserViewModel>) => {
                state.translations = action.payload.translations;
                state.currentUser = action.payload.currentUser;
                state.isImpersonating = action.payload.isImpersonating;
            }
        );
        builder.addMatcher(
            impersonateApi.endpoints.deimpersonate.matchFulfilled,
            (state, action: RTKPayloadAction<IImpersonationUserViewModel>) => {
                state.translations = action.payload.translations;
                state.currentUser = action.payload.currentUser;
                state.isImpersonating = action.payload.isImpersonating;
            }
        );
        builder.addMatcher(
            cartApi.endpoints.loadOrderIntoCart.matchFulfilled,
            (state, action: any) => {
                if (action.payload?.impersonationUser) {
                    state.translations = action.payload.impersonationUser.translations;
                    state.currentUser = action.payload.impersonationUser.currentUser;
                    state.isImpersonating = action.payload.impersonationUser.isImpersonating;
                }
            }
        );
        builder.addMatcher(
            cartApi.endpoints.unloadOrderFromCart.matchFulfilled,
            (state, action: any) => {
                if (action.payload?.impersonationUser) {
                    state.translations = action.payload.impersonationUser.translations;
                    state.currentUser = action.payload.impersonationUser.currentUser;
                    state.isImpersonating = action.payload.impersonationUser.isImpersonating;
                }
            }
        );
    },
});

export const { updateImpersonationBanner } = slice.actions;

export default slice.reducer;
